export function parseKakaoExport(raw:string){
 const messages:{speaker:string;text:string}[]=[];
 for(const line of raw.replace(/^\uFEFF/,'').split(/\r?\n/)){
  const android=line.match(/^\[([^\]]+)\]\s*\[(?:오전|오후)?\s*\d{1,2}:\d{2}\]\s?(.*)$/);
  const iphone=line.match(/^\d{4}[.\-/]\s*\d{1,2}[.\-/]\s*\d{1,2}[.]?\s*(?:오전|오후)?\s*\d{1,2}:\d{2},\s*(.+?)\s*:\s?(.*)$/);
  const match=android??iphone;
  if(match)messages.push({speaker:match[1].trim(),text:match[2]});
  else if(messages.length&&!/^[-=]{3}|^\d{4}년|저장한 날짜|님과 카카오톡 대화/.test(line))messages.at(-1)!.text+='\n'+line;
 }
 if(!messages.length)throw new Error('카톡에서 내보낸 대화 파일인지 확인해 주세요. 원문을 붙여 넣어도 돼요.');
 return messages;
}
